module.exports = __webpack_public_path__ + "static/media/loader-v01.0c83f984.gif";